import React, { useState, useEffect, useContext } from 'react';
import { scrollToTop } from '@deporvillage/utils-library-component';
import { Config, I18n } from '@deporvillage/utils-library-component';
import PropTypes from 'prop-types';

import styles from './ScrollToTopButton.module.scss';

const ScrollToTopButton = ({ breakpoint }) => {
    const { isMobile } = useContext(Config);
    const [isVisible, setIsVisible] = useState(false);

    /* eslint-disable no-undef */
    useEffect(() => {
        const toggleVisibility = () => setIsVisible(window.scrollY > breakpoint);

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, [breakpoint]);
    /* eslint-enable no-undef */

    return (
        isVisible && (
            <div className={styles['scroll-to-top-button-component']} data-testid='scroll-to-top-button-component'>
                <button className={`${styles['scroll-to-top-button']}`} onClick={scrollToTop} data-testid='scroll-to-top-button'>
                    <span className={styles['scroll-to-top-button-content']}>
                        {!isMobile ? (
                            <span data-testid={'button-scroll-text'}>
                                {' '}
                                <I18n>generic.actions.scroll_to_top</I18n>{' '}
                            </span>
                        ) : null}
                        <span className='icon icon-arrow-upward' />
                    </span>
                </button>
            </div>
        )
    );
};

ScrollToTopButton.propTypes = {
    breakpoint: PropTypes.number,
};

export default ScrollToTopButton;
